import moment from 'moment-timezone';
import numeral from 'numeral';
import { parseIntUtil } from '../../../utils/NumeralParts';

/*
 * Formatters
 *
 * Object that contains all our formats for displaying data.
 *
 */

const DEFAULT_FORMAT = '0,0.00';
const DEFAULT_SYMBOL = '₱';
export const DEFAULT_TIMEZONE = 'Asia/Manila';

const Formatters = {
  text: ((text) => { return text || '-'; }),
  amount: ({ amount = 0, format = DEFAULT_FORMAT }) => {
    return `${numeral(amount).format(format)}`
  },
  currency: ({ symbol = DEFAULT_SYMBOL, amount = 0, format = DEFAULT_FORMAT}) => {
    return `${symbol} ${numeral(amount).format(format)}`;
  },
  currencyDecimal: (number = 0, isRounded = true) => {
    if (isRounded) {
      return numeral(number).format(DEFAULT_FORMAT)
    }
    const notRounded = parseIntUtil(number * 100) / 100
    return numeral(notRounded).format(DEFAULT_FORMAT)
  },
  date: (date, format="YYYY-MM-DD") => {
    if (date === undefined) { return undefined }
    const parsedDate = moment(date, format).tz(DEFAULT_TIMEZONE)
    if(parsedDate.month() === 4) { return  parsedDate.format("MMMM D, YYYY") }
    return parsedDate.format("MMM. D, YYYY")
  },
  longDate: (date) => {
    if (date === undefined) { return undefined }
    return moment(date).tz(DEFAULT_TIMEZONE).format("MMMM D, YYYY");
  },
  dateTime: (date) => {
    if (date === undefined) { return undefined }
    return moment(date).tz(DEFAULT_TIMEZONE).format("MMM Do YYYY [at] hh:mm a");
  },
  dateDayMonthYear: (date) => {
    // 25 Apr 2018
    if (date === undefined) { return undefined }
    return moment(date).tz(DEFAULT_TIMEZONE).format("DD MMM YYYY");
  },
  upperCaseWords: (text) => {
    // your name to Your Name
    if (text === undefined) return undefined;
    return text.replace(/\b\w/g, (word) => word.toUpperCase());
  }
};

export default Formatters;



// WEBPACK FOOTER //
// ./src/features/shared/utils/Formatters.js